module.exports = __webpack_public_path__ + "img/companies.8df3e36e.svg";